/**
 * Initialize Google Tag Manager
 * @param {string} tagId - Google Tag Manager ID
 */
export const initializeGoogleTagManager = (tagId) => {
  if (!tagId) return;

  // Create and append gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', tagId);

  // Make gtag available globally
  window.gtag = gtag;
};
